import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import styled from 'styled-components';

import { CSVLink } from 'react-csv';

// Material-UI
import MuiPopover from '@material-ui/core/Popover';
import MuiList from '@material-ui/core/List';
import MuiListItem from '@material-ui/core/ListItem';
import MuiListItemIcon from '@material-ui/core/ListItemIcon';
import MuiListItemText from '@material-ui/core/ListItemText';

import { Icons, MUI, Typography } from '@styles';

const Menu = ({
  anchorMenu,
  columns,
  rows,
  exportToCSV,
  exportAllToExcel,
  exportFiltersToExcel,
  exportFileName,
  onHideColumn,
  openMenu,
  closeMenu
}) => {
  let headers = [];
  if (exportToCSV) {
    headers = columns.map(({ id, label }) => ({ label, key: id, }));
  }

  return (
    <>
      <MUI.ButtonIcon onClick={openMenu}>
        <Icons.Menu />
      </MUI.ButtonIcon>

      <Popover
        open={Boolean(anchorMenu)}
        anchorEl={anchorMenu}
        onClose={closeMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <MUI.Box padding="16px 16px 0">
          <Typography.Text>
            {`${i18n.t('GenericMessages.columns')}:`}
          </Typography.Text>
        </MUI.Box>

        <List
          component="nav"
          aria-label="column-list"
        >
          {/* Columnas */}
          {columns.map((column, index) => (
            <ListItem
              button
              key={index}
              onClick={() => onHideColumn(column)}
            >
              <ListItemIcon>
                {column.visible ? <Icons.Visibility /> : <Icons.VisibilityOff />}
              </ListItemIcon>
              <ListItemText primary={column.label} />
            </ListItem>
          ))}
        </List>
        {(exportToCSV || exportAllToExcel || exportFiltersToExcel) && (
          <>
            <MUI.Divider />
            <List
              component="nav"
              aria-label="export-list"
            >
              {exportToCSV && (
                <ListItem button>
                  <ListItemIcon>
                    <Icons.GetApp />
                  </ListItemIcon>
                  <CSVLink
                    headers={headers}
                    data={rows}
                    filename={`${exportFileName}.csv`}
                  >
                    <ListItemText primary={i18n.t('GenericMessages.exportCSV')} />
                  </CSVLink>
                </ListItem>
              )}
            </List>
          </>
        )}
      </Popover>
    </>
  );
};

Menu.propTypes = {
  // Configuración [anchorElement] del menú.
  anchorMenu: PropTypes.any,
  // Colección de columnas a mostrar en el grid. 
  columns: PropTypes.array.isRequired,
  // Registros mostrados actualmente en el grid.
  rows: PropTypes.array.isRequired,
  // Boolean que muestra la opción de exportar a csv.
  exportToCSV: PropTypes.bool,
  // Boolean que muestra la opción de exportar a todos los registrso a Excel.
  exportAllToExcel: PropTypes.bool,
  // Boolean que muestra la opción de exportar a los registrso filtrados a Excel.
  exportFiltersToExcel: PropTypes.bool,
  // Nombre que se le da al archivo cuando se exportan los registros.
  exportFileName: PropTypes.string,
  // Función que se ejecuta cuando se cambia la visibilidad de una columna.
  onHideColumn: PropTypes.func,
  // Funcion para abrir el menú.
  openMenu: PropTypes.func,
  // Función para cerrar el menú.
  closeMenu: PropTypes.func
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Popover = styled(MuiPopover)`
  .MuiPopover-paper {
    border-radius: 6px;
    border: 1px solid ${(props) => props.theme.colors.greyLight};
    box-shadow: ${(props) => props.theme.shadows.depth4};
  }
`;

const List = styled(MuiList)`
  &.MuiList-padding {
    padding-top: 8px;
    padding-bottom: 8px;
  }
`;

const ListItem = styled(MuiListItem)`
  &.MuiListItem-root {
    min-height: 40px;
    padding: 0px 16px;
  }

  & > a {
    text-decoration: none;
  }
`;

const ListItemIcon = styled(MuiListItemIcon)`
 &.MuiListItemIcon-root {
   min-width: 0;
   padding-right: 16px;
   color: ${(props) => props.theme.colors.greyDark};
 }

 .MuiSvgIcon-root {
   font-size: 20px;
 }
`;

const ListItemText = styled(MuiListItemText)`
  .MuiTypography-root {
    font-family: 'Bryant Pro Regular';
    font-size: ${(props) => props.theme.typography.bodyText};
    font-weight: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${(props) => props.theme.colors.greyDark};
    text-decoration: none;
  }
`;

export default Menu;